import { io } from 'socket.io-client';

import { authStorage } from './api';

function resolveSocketBaseUrl() {
  const raw = (process.env.REACT_APP_API_URL || 'http://localhost:3000/api').trim().replace(/\/$/, '');
  if (raw.startsWith('/') && !raw.startsWith('//')) {
    return typeof window !== 'undefined' ? window.location.origin : '';
  }
  return raw.replace(/\/api$/i, '');
}

export function connectUserProfileSocket({ userId, role, onProfileUpdated }) {
  const accessToken = authStorage.getAccessToken();
  if (!accessToken || !userId || !role) {
    return () => {};
  }

  const socket = io(resolveSocketBaseUrl(), {
    transports: ['websocket', 'polling'],
  });

  const authenticate = () => {
    socket.emit('authenticate', {
      userId,
      role,
      token: accessToken,
    });
  };

  socket.on('connect', authenticate);
  socket.on('user-profile:updated', () => {
    if (typeof onProfileUpdated === 'function') {
      onProfileUpdated();
    }
  });

  return () => {
    socket.off('connect', authenticate);
    socket.off('user-profile:updated');
    socket.disconnect();
  };
}
